// #region Imports

// Angular
import { Component, EventEmitter, Output } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {
  @Output() backClicked = new EventEmitter();

  onBackClicked(e: any) {
    e.preventDefault();
    this.backClicked.emit();
  }
}
